import { useFunction } from "@aec-craft/nb-generative";
import { Button } from "@app/ui";
import { useClerk, useOrganization, useUser } from "@clerk/react";
import { useTranslate } from "@fe/i18n/use-translate";
import { usePostHog } from "@posthog/react";
import { LogOutIcon } from "lucide-react";
import { type PropsWithChildren, useEffect } from "react";

export const HasOrganization = ({ children }: PropsWithChildren) => {
	const { user } = useUser();
	const t = useTranslate();
	const { signOut, setActive } = useClerk();
	const { organization } = useOrganization();
	const posthog = usePostHog();

	const hasOrgMembership = user && user.organizationMemberships.length > 0;

	const handleSignOut = useFunction(() => {
		posthog?.reset();
		signOut();
	});

	useEffect(() => {
		if (organization) return;

		// If no active organisation set to the first one in org list
		if (user && user.organizationMemberships.length > 0) {
			const firstOrg = user.organizationMemberships[0].organization;
			setActive({ organization: firstOrg });
		}
	}, [organization, setActive, user]);

	return hasOrgMembership ? (
		children
	) : (
		<div className="absolute inset-0 z-1000 flex flex-col items-center justify-center gap-4 bg-background text-center">
			<p>{t.errorMessages.organizationError.message}</p>
			<p className="mb-4">
				{t.errorMessages.organizationError.action}
				<a
					href="https://neobim.ai/#demo"
					className="text-primary underline underline-offset-4"
				>
					{t.errorMessages.organizationError.link}
				</a>
			</p>
			<Button onClick={handleSignOut}>
				{t.userMenu.signOut}
				<LogOutIcon className="ml-2 size-4" />
			</Button>
		</div>
	);
};
